import { Receipt, Package, BarChart3, Settings } from "lucide-react";
import { Button } from "@finora/ui";

const FEATURES = [
  { icon: Receipt, title: "Fiskalni računi", desc: "Brzo i jednostavno pratite sve fiskalne račune." },
  { icon: Package, title: "Roba i zalihe", desc: "Vodite evidenciju o robi i zalihama." },
  { icon: BarChart3, title: "Izveštaji", desc: "Jasni i pregledni izveštaji za bolje odluke." },
  { icon: Settings, title: "Sve na jednom mestu", desc: "Upravljajte poslovanjem jednostavno i efikasno." },
];

export function WelcomeStep({ onNext }: { onNext: () => void }) {
  return (
    <div className="grid gap-6 rounded-xl border border-border bg-surface p-8 shadow-subtle md:grid-cols-2">
      <div>
        <p className="mb-2 text-xs font-semibold uppercase tracking-wide text-brand">
          Hvala što ste odabrali HAFiskal
        </p>
        <h1 className="mb-3 text-2xl font-bold text-slate-900">Dobrodošli u HAFiskal! 👋</h1>
        <p className="mb-6 text-sm text-slate-500">
          Hajde da podesimo vaš nalog. Ovo će trajati samo nekoliko minuta, a nakon toga možete odmah da počnete
          sa radom.
        </p>

        <div className="grid grid-cols-2 gap-4">
          {FEATURES.map(({ icon: Icon, title, desc }) => (
            <div key={title} className="flex items-start gap-2">
              <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-brand-light text-brand">
                <Icon className="h-4 w-4" />
              </div>
              <div>
                <p className="text-sm font-medium text-slate-900">{title}</p>
                <p className="text-xs text-slate-500">{desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 rounded-lg bg-app-bg p-3 text-xs text-slate-500">
          <span className="font-medium text-slate-700">Zašto onboarding? </span>
          Kratko podešavanje nam pomaže da prilagodimo HAFiskal vašem poslovanju i omogućimo vam najbolje iskustvo.
        </div>
      </div>

      <div className="flex flex-col items-center justify-center gap-6 rounded-xl bg-brand-light p-8 text-center">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-white text-3xl shadow-subtle">
          🚀
        </div>
        <p className="text-sm font-medium text-slate-700">Uspešnije poslovanje počinje ovde.</p>
        <Button onClick={onNext} className="w-full max-w-xs">
          Nastavi →
        </Button>
        <span className="text-xs text-slate-400">Korak 1 od 6</span>
      </div>
    </div>
  );
}
